(function () {
  'use strict';

  if (window.__PGContentProtectionV60) return;
  window.__PGContentProtectionV60 = true;

  if (window.Shopify && window.Shopify.designMode) return;

  var protectedMediaSelector = 'img, picture, video, canvas, svg image, [data-pg-protected-media]';
  var copyAllowedSelector = 'input, textarea, select, option, [contenteditable="true"], [data-pg-copy-allowed]';
  var toastTimer = null;

  function asElement(node) {
    if (!node) return null;
    return node.nodeType === 1 ? node : node.parentElement;
  }

  function isCopyAllowed(target) {
    var element = asElement(target);
    return Boolean(element && element.closest(copyAllowedSelector));
  }

  function isProtectedMedia(target) {
    var element = asElement(target);
    return Boolean(element && element.closest(protectedMediaSelector));
  }

  function selectionIsInsideAllowedField() {
    var selection = window.getSelection && window.getSelection();
    if (!selection || selection.rangeCount === 0) return false;
    return isCopyAllowed(selection.anchorNode) && isCopyAllowed(selection.focusNode);
  }

  function showProtectionNotice() {
    if (!document.body) return;

    var toast = document.getElementById('pg-content-protection-notice-v60');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'pg-content-protection-notice-v60';
      toast.className = 'pg-content-protection-notice-v60';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.textContent = 'Paw & Glory artwork and content are protected.';
      document.body.appendChild(toast);
    }

    toast.classList.add('pg-content-protection-notice-v60--visible');
    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('pg-content-protection-notice-v60--visible');
    }, 1800);
  }

  function blockWithNotice(event) {
    event.preventDefault();
    event.stopPropagation();
    showProtectionNotice();
  }

  document.addEventListener('contextmenu', function (event) {
    if (isCopyAllowed(event.target)) return;
    blockWithNotice(event);
  }, true);

  document.addEventListener('dragstart', function (event) {
    if (!isProtectedMedia(event.target)) return;
    blockWithNotice(event);
  }, true);

  document.addEventListener('selectstart', function (event) {
    if (isCopyAllowed(event.target)) return;
    event.preventDefault();
  }, true);

  document.addEventListener('copy', function (event) {
    if (isCopyAllowed(event.target) || selectionIsInsideAllowedField()) return;
    blockWithNotice(event);
  }, true);

  document.addEventListener('keydown', function (event) {
    var key = String(event.key || '').toLowerCase();
    var modifier = event.ctrlKey || event.metaKey;
    var devModifier = event.ctrlKey || event.metaKey;
    var altOrShift = event.altKey || event.shiftKey;

    if (key === 'printscreen') {
      showProtectionNotice();
      return;
    }

    if (key === 'f12') {
      blockWithNotice(event);
      return;
    }

    if (!modifier) return;

    if (key === 'c' && !event.shiftKey && !event.altKey) {
      if (isCopyAllowed(event.target)) return;
      blockWithNotice(event);
      return;
    }

    if (key === 's' || key === 'p' || key === 'u') {
      blockWithNotice(event);
      return;
    }

    if (devModifier && altOrShift && (key === 'i' || key === 'j' || key === 'c')) {
      blockWithNotice(event);
    }
  }, true);
})();
